import _get from 'lodash/get';

/** @returns {import("zod").z.infer<typeof import("./stubs").FORM_SCHEMA>} */
export const createFormData = data => {
  const returnFee = _get(data, 'return_fee', '');
  const exchangeFee = _get(data, 'exchange_fee', '');

  return {
    ...data,
    return_fee: `${returnFee}`,
    exchange_fee: `${exchangeFee}`
  };
};

/** @param {import("zod").z.infer<typeof import("./stubs").FORM_SCHEMA>} data */
export const createPayload = data => {
  const payload = { ...data };

  delete payload.id;

  return {
    ...payload,
    return_fee: +data.return_fee,
    exchange_fee: +data.exchange_fee
  };
};
